import { Visit, VisitTemplate } from '@dreryk/egabinet-visit-frontend-api';

import { AssignmentIcon, ControlsBar, Link, LinkSize, SaveFileIcon } from '@dreryk/react-components';

import { visitTranslationKeys } from '../../../translations';
import { VisitTemplatesModalOpener } from '../../../visitTemplates';
import { VisitFormBean, VisitFormController } from '../visitForm.types';

import { useApplyVisitTemplateWithDraftSave } from './VisitTemplateControlsBarActionsPortal.hooks';

type VisitTemplatesControlsBarActionsPortalProps = {
   readonly visit: Visit;
   readonly formController: VisitFormController;
};

const mapVisitToVisitTemplate = (visitFormBean?: VisitFormBean): Omit<VisitTemplate, 'name' | 'id'> => ({
   physicalExamination: visitFormBean?.subjectiveAssessments?.getFormattedValue() ?? '',
   recommendations: visitFormBean?.recommendations?.getFormattedValue() ?? '',
   interview: visitFormBean?.interview?.getFormattedValue() ?? '',
});

export const VisitTemplatesControlsBarActionsPortal = (
   props: VisitTemplatesControlsBarActionsPortalProps
): JSX.Element => {
   const applyVisitTemplateWithDraftSave = useApplyVisitTemplateWithDraftSave({
      visitId: props.visit.id,
      controller: props.formController,
   });

   return (
      <ControlsBar.Main position={'right'}>
         <VisitTemplatesModalOpener
            defaultTemplate={() => mapVisitToVisitTemplate(props.formController.getValues() as VisitFormBean)}
            onInsert={applyVisitTemplateWithDraftSave}
         >
            {({ openModal }) => (
               <Link
                  testId={'saveAsTemplate'}
                  label={visitTranslationKeys.controlsBar.saveAsTemplate}
                  onClick={openModal}
                  icon={<SaveFileIcon />}
                  size={LinkSize.NORMAL}
               />
            )}
         </VisitTemplatesModalOpener>
         <VisitTemplatesModalOpener onInsert={applyVisitTemplateWithDraftSave} defaultTemplate={undefined}>
            {({ openModal }) => (
               <Link
                  testId={'insertFromTemplate'}
                  label={visitTranslationKeys.controlsBar.insertFromTemplate}
                  onClick={openModal}
                  icon={<AssignmentIcon />}
                  size={LinkSize.NORMAL}
               />
            )}
         </VisitTemplatesModalOpener>
      </ControlsBar.Main>
   );
};
